module.exports = __webpack_public_path__ + "static/media/StudiesIcon.85f1de97.svg";